import { Interweave } from "interweave";
import { Modal } from "react-bootstrap";

export default function ExerciseInfoModal({
  currentExercise,
  viewportWidth,
  isOpen,
  onClose,
}) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      id=""
      className="modal fade custom-modal-style muscles-modal"
      aria-hidden="true"
      aria-labelledby="exampleModalLabel"
      size="xl"
      centered
    >
      <Modal.Header>
        <h4>Exercise Details</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <div className="container mt-3 mb-3">
        <div className="row mb-3">
          <div className="col-9 col-md-7">
            <h4 className="mb-20">
              {currentExercise?.exerciseLevel?.file_name || ""}
            </h4>
          </div>
        </div>
        <div>
          {currentExercise.exerciseLevel.starting_position && (
            <>
              <h6>Starting Position</h6>
              <p>
                <Interweave
                  content={currentExercise.exerciseLevel.starting_position}
                />
              </p>
            </>
          )}

          {currentExercise.exerciseLevel.movements && (
            <>
              <h6>Movement</h6>
              <p>
                <Interweave content={currentExercise.exerciseLevel.movements} />
              </p>
            </>
          )}

          {currentExercise.exerciseLevel.notes && (
            <div className="exc_p">
              <p>
                <span>Note:</span>
                <Interweave content={currentExercise.exerciseLevel.notes} />
              </p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
